import * as MetaTypes from './metaConnections.types';
import {
  IInitialMetaState,
  TSftpUserItem,
  TShopifyConnectionItem,
} from 'interfaces/meta.interface';

export type TMetaConnectionsDispatchReducer =
  | {
      type: typeof MetaTypes.SET_IS_LOADING_CONNECTIONS;
      payload: boolean;
    }
  | {
      type: typeof MetaTypes.SET_SFTP_CONNECTIONS;
      payload: Array<TSftpUserItem>;
    }
  | {
      type: typeof MetaTypes.SET_SHOPIFY_CONNECTIONS;
      payload: Array<TShopifyConnectionItem>;
    };

export function handleMetaConnections(
  state: IInitialMetaState,
  action: TMetaConnectionsDispatchReducer
) {
  const { type, payload } = action;

  switch (type) {
    case MetaTypes.SET_IS_LOADING_CONNECTIONS: {
      const setConnections: IInitialMetaState = {
        ...state,
        isLoadingConnections: payload,
      };
      return setConnections;
    }

    case MetaTypes.SET_SFTP_CONNECTIONS: {
      const setSftpConnections: IInitialMetaState = {
        ...state,
        sftp: {
          ...state.sftp,
          connections: payload,
        },
      };
      return setSftpConnections;
    }

    case MetaTypes.SET_SHOPIFY_CONNECTIONS: {
      const setShopifyConnections: IInitialMetaState = {
        ...state,
        shopify: {
          ...state.shopify,
          connections: payload,
        },
      };
      return setShopifyConnections;
    }

    default:
      return state;
  }
}
